import React, { useState, useEffect } from "react";

import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import { Link } from "react-router-dom";

// import actions
import { connect } from "react-redux";
import {
  setAllCategories,
  setAllMerchants,
} from "../../store/cms-actions/postActions";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import { CheckPermission } from "../Permissions/CheckPermissions";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const HomepageCards = (props) => {
  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" },
  ];

  const [data, setData] = useState([]);
  const [sortBy, setSortBy] = useState(sortOptions[0].value);
  const [token, setToken] = useState("");
  const [success_msg, setsuccess_msg] = useState(false);
  const [errorMessage, SetErrorMessage] = useState("");
  const [errorMsgAlert, setErrorMsgAlert] = useState(false);
  const [ItemForDelete, setItemForDelete] = useState("");
  const [del, setDelete] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getHomepageCards(token);
    return () => {};
  }, [sortBy, success_msg]);

  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.id, token);
          setDelete(false);
        }}
        onCancel={() => setDelete(false)}
        show={true}
      >
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    );
  };

  const getHomepageCards = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/homepagecards/`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        let tempData = [];
        if (result) {
          tempData = [...result.data];
          /*Sorting according to postion and date */
          console.log("here is the homepage card data---->", tempData);
          tempData.sort((a, b) => {
            if (a.sort_order == b.sort_order) {
              return Date.parse(b.publish_date) - Date.parse(a.publish_date);
            } else {
              return a.sort_order - b.sort_order;
            }
          });
          console.log("here is the temp data---->", tempData);
          setData(tempData);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/homepagecards/${ID}`,
      requestOptions
    )
      .then((response) => {
        if (response.status == 202) {
          setsuccess_msg(true);
        } else {
          setErrorMsgAlert(true);
        }
        response.text();
      })
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          setsuccess_msg(false);
          props.history.go(0);
        }}
        onCancel={() => {
          setsuccess_msg(false);
        }}
      >
        {"Homepage Card deleted successfully."}
      </SweetAlert>
    );
  };
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };
// console.log("here is the chack permission returning values---->",CheckPermission("homepagecards"))
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="More" breadcrumbItem="Homepage Cards" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle className="h4">
                    <Row>
                      <Col lg={6} md={12} sm={12}>
                        <Button
                         disabled={!CheckPermission("homepagecards","add")}
                          className="btn btn-success waves-effect waves-light"
                          onClick={() => {
                            props?.history?.push("/add-homepage-card", {
                              estore: true,
                            });
                          }}
                        >
                          <FaPlus size={12} /> Add Homepage Card
                        </Button>
                      </Col>
                      <Col
                        lg={6}
                        md={12}
                        sm={12}
                        style={{ textAlign: "right" }}
                      >
                        <div className="mb-3">
                          {/* <Label>Discount Type</Label> */}
                          <label htmlFor="cars">Status</label>

                          <select
                            name="cars"
                            defaultValue={sortOptions[0].value}
                            id="cars"
                            onChange={(e) => {
                              setSortBy(e.target.value);
                            }}
                            style={{ width: 80, height: 30, marginLeft: 10 }}
                          >
                            {sortOptions?.map((item, index) => {
                              return (
                                <option key={index} value={item.value}>
                                  {item.label}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </CardTitle>

                  <div className="table-responsive">
                    <table className="table table-bordered border-primary mb-0">
                      <thead>
                        <tr>
                          <th>title</th>
                          <th>Description</th>
                          {/* <th>Navigate to</th> */}
                          <th>Icon</th>
                          <th>Publish At</th>
                          <th>Unpublish At</th>
                          <th>Status</th>
                          <th>Action</th>
                          <th>Position</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => {
                          if (sortBy == "enabled") {
                            if (item?.status !== "Y") {
                              return;
                            }
                          }
                          return (
                            <tr key={index}>
                              <td>{item?.title}</td>
                              <td>{item?.description}</td>
                              {/* <td>{item?.navigate_to}</td> */}
                              <td>
                                <img
                                  src={item?.userfile}
                                  style={{ width: 50 }}
                                  alt=""
                                />
                              </td>
                              <td>
                                {moment(item?.publish_date).format(
                                  "DD/MM/YYYY h:mm a"
                                )}
                              </td>
                              <td>
                                {item?.unpublish_date == null
                                  ? "Never-Ending"
                                  : moment(item?.unpublish_date).format(
                                      "DD/MM/YYYY h:mm a"
                                    )}
                              </td>
                              <td>
                                {item?.status == "Y" ? (
                                  <Button
                                    color="success"
                                    className="btn-soft-success waves-effect waves-light"
                                  >
                                    Enabled
                                  </Button>
                                ) : (
                                  <Button
                                    color="danger"
                                    className="btn-soft-danger waves-effect waves-light"
                                  >
                                    Disabled
                                  </Button>
                                )}
                              </td>
                              <td>
                                <Row>
                                  <div className="d-flex justify-content-around">
                                    {CheckPermission("homepagecards","update") && <div
                                      style={{ width: 30, textAlign: "center" }}
                                      onClick={() => {
                                        props?.history?.push(
                                          "/edit-homepage-card",
                                          { edit: true, item: item }
                                        );
                                      }}
                                      className="text-primary"
                                    >
                                      <a
                                        className="font-size-18"
                                        onClick={() => {
                                          props?.history?.push(
                                            "/edit-homepage-card",
                                            { edit: true, item: item }
                                          );
                                        }}
                                      ><FaPen /></a>
                                    </div>}
                                    {success_msg ? renderSuccessAlert() : null}
                                    {errorMsgAlert
                                      ? renderFailureAlert()
                                      : null}
                                    {/* onClick={() => { deleteEntry(item?.item_id, token) }} */}
                                   {CheckPermission("homepagecards","delete") && <div  style={{ width: 30 }}>
                                      <Link  to="#" className="px-2 text-danger">
                                        <i
                                          className="font-size-18"
                                          onClick={() => {
                                            setItemForDelete(item);
                                            setDelete(true);
                                          }}
                                        ><FaRegTrashAlt /></i>
                                      </Link>
                                    </div>}
                                  </div>
                                </Row>
                              </td>
                              <td>{item?.sort_order}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        {del ? handleConfirmation() : null}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { allCategories, allMerchants } = state.rootReducers1;
  return { allCategories, allMerchants };
};

const actions = {
  setAllCategories,
  setAllMerchants,
};

export default connect(mapStateToProps, actions)(HomepageCards);
